import React from "react";
import Hero from "../../components/hero";
import Layout from "../../components/Layout/Page";
import LOCATIONICON from "../../assets/icons/locationIcon.png";
import TELEPHONEICON from "../../assets/icons/callIcon.png";
import EMAILICON from "../../assets/icons/messageIcon.png";
import { Input, message } from "antd/lib";

import {
  CardContainer,
  ContactDetails,
  Description,
  Heading,
  Icon,
  InnerBackgroundContainer,
  MainContainer,
  Name,
  TitleContainer,
  WriteUSCard,
  InnerLeftContainer,
  Heading2,
  BottomContanier,
  Line,
  Label,
  Text,
  HorizontalLine,
  InnerRightContainer,
  Button,
  Icon2,
  ContactDetailsHeadOffice,
  ContactNumbers
} from "./styled.components";
import { useState } from "react";
import axios from "axios";
import { BACKEND_URL } from "../../constants/urls";
const { TextArea } = Input;

const ContactUs = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [textArea, setTextArea] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(`${BACKEND_URL}/contact`, {
        name,
        email,
        message: textArea,
      })
      .then((result) => {
        if (result.data.error) {
          message.error(result.data.message);
        } else {
          message.success(result.data.message);
        }
      })
      .catch((e) => {
        message.error(e.message);
      });
  };
  return (
    <Layout className="">
      <Hero
        title="Contact Us"
        SubTitle="HHH and Sons Presents a Proud Past And Will Keep The Promise For Days To Come"
      />
      <MainContainer>
        <InnerBackgroundContainer>
          <CardContainer className="col-md-8 col-9 mx-auto">
            <Heading>3H And Sons</Heading>
            <ContactDetails className="row d-flex flex-wrap">
              <TitleContainer className="col-md-4">
                <Icon2 src={LOCATIONICON} alt="locationIcon" />
                <Name>Location</Name>
                <Description>
                  Plaza 34 Road E Block C commercial 1 (NS-1) Naval Anchorage
                  Islamabad
                </Description>
              </TitleContainer>

              <TitleContainer className="col-md-4">
                <Icon src={TELEPHONEICON} alt="telephoneicon" />
                <Name>Telephone</Name>
                <Description>(+92) 515159280</Description>
              </TitleContainer>
              <TitleContainer className="col-md-4">
                <Icon src={EMAILICON} alt="emailIcon" />
                <Name>Email</Name>
                <Description>3hs.global.team@gmail.com</Description>
              </TitleContainer>
            </ContactDetails>
            <ContactDetailsHeadOffice>
              <TitleContainer className="col-md-4">
                <Icon2 src={LOCATIONICON} alt="locationIcon" />
                <Name>Head Office</Name>
                <Description>
                  Near Benazir Chowk Hasnain Nagar Skardu Gilgit Baltistan{" "}
                </Description>
              </TitleContainer>
              <ContactNumbers>
                <Description>(+92) 455088036</Description>
                <Description>(+92) 445500043</Description>
                <Description>(+92) 469558424</Description>
              </ContactNumbers>
            </ContactDetailsHeadOffice>
          </CardContainer>
          <BottomContanier className="row">
            <WriteUSCard className="col-md-8 col-9 row mx-auto p-0 flex-wrap w-100">
              <InnerLeftContainer className="col-md-6 w-100">
                <Heading2>Write Us</Heading2>
                <Line />
                <Label>Name</Label>
                <Input onChange={(e) => setName(e.target.value)} />
                <Label>Email</Label>
                <Input onChange={(e) => setEmail(e.target.value)} />
                <Text>Reference documents available on request</Text>
              </InnerLeftContainer>
              <InnerRightContainer className="col-md-6 w-100">
                <TextArea
                  rows={8}
                  onChange={(e) => setTextArea(e.target.value)}
                  placeholder="Write your Message"
                />
                <Button onClick={handleSubmit}>Send Message</Button>
              </InnerRightContainer>
            </WriteUSCard>
          </BottomContanier>
        </InnerBackgroundContainer>
      </MainContainer>
    </Layout>
  );
};

export default ContactUs;
